export default __webpack_public_path__ + "static/media/gray-bg.e6c6137b.png";